import React from 'react';
import {Icon, Dropdown, Menu, message, Select} from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import Detail from './components/Receiv/Detail';
import Edit from './components/Receiv/Edit';
import Delete from './components/Receiv/delete';
import {dicPayType, ReceivablesType, syncStatusIsMap} from '../../axios/dictionaries'
import { postFrom, config, transterQuery } from '../../axios';
import axios from 'axios'
import moment from 'moment'
import {moneyAddComma, handleExportParams, isPlatform} from '../../utils/index';
import JrApiLog from "../Other/JrApiLog";
import map from "react-error-overlay/lib/utils/mapper";

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: {
                billBeginDate: "",
                billEndDate: "",
                billId: "",
                buildingName: "",
                contractId: "",
                customerId: "",
                customerName: "",
                houseId: "",
                keyword: "",
                merchantName: "",
                mustPayDateEnd: "",
                mustPayDateStart: "",
                pageSize: 10,
                phone: "",
                projectName: "",
                receiveStatus: 2,
                roomNo: "",
                shortName: "",
                receiveOrPay: 1,
                payType:"",
                feeName:'',
            }, //搜索参数
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showDetailModal: false, //显示详情
            showEditModal: false, //显示编辑
            showDeleteModal: false, //显示收款
            inputSearchTerm: "175px", //查询条件宽度
            tableTotalMny: 0, //总金额
            feeTypes: [], //收款类别
        }
    }

    componentDidMount() {

        postFrom({ url: config.API_dictionary_findList, data: { groupName: '收款类别' } }).then(res => {
            let result = [];
            for (let key in res) {
                result.push({
                    title: res[key]['dicValue'],
                    value: res[key]['dicValue']
                })
            }

            this.setState({ feeTypes: result });
        }).catch(err => {
            message.error(err.message || '获取收款类别失败');
        });

        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current, merchantId } = this.state;
        let data = {};
        if (values.current) {
            data = Object.assign({}, params, values, { merchantId });
        } else {
            data = Object.assign({}, params, values, { current, merchantId });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        axios.all([
            postFrom({ url: config.API_bill_findBillPageList, data }),
            postFrom({ url: config.API_bill_findBillCount, data }),
        ]).then(axios.spread((listRes, countRes) => {
            this.setState({ tableTotalMny: countRes.billTotalMoney, tableTotal: listRes.total, current: listRes.current, tableData: listRes.records, tableLoading: false });
        })).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        })
    }

    handleJrApiLogInfo(tableName,id) {
        //console.log(this);
        this.jrApiLogRef.open(tableName,id);
    }

    handleShowDetail = (id) => { //显示详情
        this.setState({ showDetailModal: true });
        this.detailRef.loadPackage(id);
    }

    handleShowEdit = (id) => { //修改
        this.setState({ showEditModal: true });
        this.editRef.loadPackage(id);
    }

    // handleShowReceivables = (id) => { //收款
    //     this.setState({ showDeleteModal: true });
    //     this.deleteRef.loadPackage(id);
    // }

    handleDelete = (id) => { //删除
        this.setState({ showDeleteModal: true });
        this.deleteRef.loadPackage(id);
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showDetailModal,
            showEditModal,
            showDeleteModal,
            inputSearchTerm,
            tableTotalMny,
            feeTypes,
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper search-wrapper-two" style={{ flexDirection: 'column', }}>
                    <SuperForm
                        data={searchData(inputSearchTerm,feeTypes)}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                    <div className="search-btn-list template-style">
                        <AuthButton authkey="e-1-5" type="primary" icon="import" href={`${config.API_bill_collectionBillExprotDate}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                            导出
                        </AuthButton>
                    </div>
                </div>

                <TableDOM
                    columns={columns({ current, handleShowDetail: this.handleShowDetail, handleShowEdit: this.handleShowEdit, handleDelete: this.handleDelete,handleJrApiLogInfo:this.handleJrApiLogInfo.bind(this) })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    totalMny={tableTotalMny}
                    current={current}
                    onChange={this.handleSearch}
                    hint="实际到帐以第三方支付结算为准。"
                />
                <Detail
                    onRef={ref => this.detailRef = ref}
                    visible={showDetailModal}
                    handleCancel={() => { this.setState({ showDetailModal: false }) }}
                />
                <Edit
                    onRef={ref => this.editRef = ref}
                    visible={showEditModal}
                    handleCancel={() => { this.setState({ showEditModal: false }) }}
                    handleSearch={this.handleSearch}
                />
                <Delete
                    onRef={ref => this.deleteRef = ref}
                    visible={showDeleteModal}
                    handleCancel={() => { this.setState({ showDeleteModal: false }) }}
                    handleSearch={this.handleSearch}
                />
                <JrApiLog ref={ref=>{
                    this.jrApiLogRef=ref;
                }}/>
            </PageWrap>
        )
    }
}


const searchData = (inputSearchTerm,feeTypes) => {
    let data = [
        {
            tagName: 'Input',
            formConfig: { name: 'shortName' },
            attribute: { placeholder: '输入商户简称', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'projectName' },
            attribute: { placeholder: '输入项目名称', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'buildingName' },
            attribute: { placeholder: '输入楼栋', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'roomNo' },
            attribute: { placeholder: '输入房号', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'mustPayDateStart' },
            attribute: { placeholder: '请选择应收开始日期', style: { width: "172.7px" } },
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'mustPayDateEnd' },
            attribute: { placeholder: '请选择应收结束日期', style: { width: "172.7px" } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'customerName' },
            attribute: { placeholder: '输入租客', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'phone' },
            attribute: { placeholder: '输入手机号码', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'mustPayDateStart1' },
            attribute: { placeholder: '请选择结清开始日期', style: { width: "172.7px" } },
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'mustPayDateEnd1' },
            attribute: { placeholder: '请选择结清结束日期', style: { width: "172.7px" } },
        },
        {
            tagName: 'Select',
            formConfig: { name: 'receiveStatus',options:{initialValue:2} },
            attribute: { placeholder: '请选择账单状态', style: { width: inputSearchTerm }, },
            optionData: [{ title: '全部', value: '' },{ title: '历史迁移', value:10}].concat(ReceivablesType), //.concat(dicHouseStatus)
            notResult: '',
        },

        {
            tagName: 'Select',
            formConfig: { name: 'payType' },
            attribute: { placeholder: '请选择交易方式', style: { width: inputSearchTerm } },
            optionData: [{ title: '全部', value: '' }].concat(dicPayType), //.concat(dicHouseStatus)
            notResult: '',
        },
        {
            tagName: 'Select',
            formConfig: { name: 'syncStatus' },
            attribute: { placeholder: '请选择同步状态', style: { width: inputSearchTerm } },
            optionData: [{ title: '全部', value: '' }].concat(syncStatusIsMap), //.concat(dicHouseStatus)
            notResult: '',
        },
        {
            tagName: 'SelectMultiple',
            formConfig: { name: 'feeName',},
            attribute: { placeholder: '请选择账单费项', style: { width: "280px" } },
            optionData: [{ title: '全部', value: '' }].concat(feeTypes), //.concat(dicHouseStatus)
            notResult: '',
        },
    ];
   // handleExportParams().merchantId ? data.splice(0, 1) : '';

    //判断是否平台，未平台则把syncStatus=> 同步状态 及商户简称查询查询条件取消

    data = data.filter(e => {
        if(isPlatform()){
            return true;
        }
        if ( e.formConfig.name === 'shortName') {
            return false;
        }
        return true;
    });

    return data;
};
const columns = ({ current, handleShowDetail, handleShowEdit, handleDelete,handleJrApiLogInfo }) => [
    {
        title: '应收日期',
        dataIndex: 'mustPayDate',
        render(text, record, index) {
            return <span >
                <div style={{ color: "red" }}>{record.overdueDays ? `逾期${record.overdueDays}天` : null}</div>
                <div>{record.mustPayDate ? moment(record.mustPayDate).format('YYYY-MM-DD') : ""}</div>
            </span>
        }
    },
    {
        title: '房源',
        dataIndex: 'houseId',
        render(text, record, index) {
            return <span >
                <div>{record.roomNo ? record.roomNo : null}</div>
                <div>{record.buildingName ? record.buildingName : null}</div>
            </span>
        }
    },
    {
        title: '租客',
        dataIndex: 'customerName',

        render(text, record, index) {
            return <span >
                <div>{record.customerName ? record.customerName : null}</div>
                <div>{record.phone ? record.phone : null}</div>
            </span>
        }
    },
    {
        title: '账单名称',
        dataIndex: 'feeName'
    },
    {
        title: '账单周期',
        dataIndex: 'billBeginDate',
        render(text, record, index) {
            return <span >
                <div>{record.billBeginDate ? moment(record.billBeginDate).format('YYYY-MM-DD') : null}</div>
                <div>{record.billEndDate ? moment(record.billEndDate).format('YYYY-MM-DD') : null}</div>
            </span>
        }
    },
    {
        title: '应收 | 已收（元）',
        dataIndex: 'receivedMoney',
        align: "right",
        render(text, record, index) {
            return <span>
                <div>{moneyAddComma(record.billMoney)}</div>
                {record.receivedMoney ? <div style={{ color: "red" }}>{moneyAddComma(record.receivedMoney)}</div> : null}
            </span>
        }
    },
    {
        title: '账单状态 | 结清日期',
        dataIndex: 'receiveStatus',
        render(text, record, index) {
            let now = ReceivablesType.find(item => item.value === text);
            if (now)
                return <span >
                    <div>{record.historyBill ? "历史迁移" : now.title}</div>
                    <div>{record.finishDate ? moment(record.finishDate).format('YYYY-MM-DD') : null}</div>
                </span>
            return null
        }
    },
    // {
    //     title: '同步状态 | 建融Id',
    //     dataIndex: 'name33',
    //     render(text, record, index) {
    //         return <span>
    //             <div>{record.jrBillId ? "同步成功" : "未同步"}</div>
    //             {
    //                 record.jrBillId
    //                     ? <React.Fragment>
    //                         <div>{record.jrBillId ? record.jrBillId : ''}</div>
    //                     </React.Fragment>
    //                     : null
    //             }
    //         </span>
    //     }
    // },
    {
        title: '商户 | 项目',
        dataIndex: 'mustPhayDdate1',
        render(text, record, index) {
            return <span >
                <div>{record.shortName ? record.shortName : null}</div>
                <div>{record.projectName ? record.projectName : null}</div>
            </span>
        }
    },

    {
        title: '操作',
        dataIndex: 'action',
        width: 150,

        render(text, record, index) {
            const moreMenu = (<Menu>
                <AuthButton authkey="e-1-3">
                    <div className="ant-dropdown-menu-item" onClick={() => { handleShowEdit(record.id) }}>
                        编辑
                    </div>
                </AuthButton>
                <AuthButton authkey="e-1-4"><div className="ant-dropdown-menu-item" onClick={() => { handleDelete(record.id) }}>删除</div></AuthButton>
            </Menu>)

            return <span>
                <AuthButton authkey="e-1-2"><span className="showClickDetail" onClick={() => { handleShowDetail(record.id) }} style={{ margin: '0 10px 0 0' }} >详情</span></AuthButton>
                {/*<AuthButton authkey="e-1-6"><span className="showClickDetail" onClick={() => { handleJrApiLogInfo('bill',record.id) }} style={{ margin: '0 10px 0 0' }} >建融日志</span></AuthButton>*/}
                {/* <Icon style={{ fontSize: '20px' }} type="edit" onClick={() => { handleShowEdit(record.id) }} title="修改" />
                <Icon style={{ fontSize: '20px', marginLeft: '10px' }} type="transaction" onClick={() => { handleShowReceivables(record.id) }} title="收款" />
                <Popconfirm placement="topLeft" title={<span>确定删除<span style={{ color: 'blue' }}>{record.name}</span>&#8195;<span style={{ color: 'blue' }}>{record.phone}</span>的账单吗？</span>} onConfirm={() => { handleDelete(record.id) }}>
                    <Icon style={{ fontSize: '20px', marginLeft: '10px' }} type="delete" title="删除" />
                </Popconfirm> */}
                {
                    record.receiveStatus ?
                        record.receiveStatus === 2 ?
                                <AuthButton authkey={['e-1-3','e-1-4']}>
                                    <Dropdown overlay={moreMenu}>
                                        <a href="javascript:void(0);"><Icon type="down" /></a>
                                    </Dropdown>
                                </AuthButton>
                            :
                            null
                        : null
                }

            </span >
        }
    },
];


// WEBPACK FOOTER //
// ./src/page/Bill/Receiv.js